// extracted by mini-css-extract-plugin
export var legendIndicator = "_em-1";
export var legendRight = "_em-0";